import React, { Fragment } from 'react';
import { Dropdown } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useAppUser } from 'App/components/utils/providers/AppUserProvider';
import { useWorkspaceHook } from './hooks/useWorkspaceHook';
import { useWorkspacesApi } from 'Services/hooks/ApiHook';
import { SwitchWorkspaceResponseClass, WorkspaceClass } from '@emilgroup/auth-sdk';
import { TokenResponse } from 'Services/api/auth/base';
import classNames from 'classnames';
import { useAppLogger } from 'Services/logger';

export type Workspace = WorkspaceClass & {
  isDisabled: boolean;
};

export interface NavWorkspacesProps {
  workspaces: Workspace[];
}

export const NavWorkspaces: React.FC<NavWorkspacesProps> = ( { workspaces } ) => {
  const { t } = useTranslation( [ 'base' ] );
  const logger = useAppLogger();
  const utils = useWorkspaceHook();
  const currentAccount = useAppUser();
  const workspaceService = useWorkspacesApi();

  const showUnmanagedLoader = React.useCallback( () => {
    const elm = document.createElement( 'div' );
    const css = `modal-full-container show d-flex justify-content-center
    align-items-center h-100 w-100 z-[100] position-fixed`;
    elm.innerHTML = `<div style="top:0; left:0" class="${css}">
      <span class="spinner-border text-primary"></span></div>`;
    document.body.append( elm );
  }, [] );

  const handleWorkspaceSwitch = React.useCallback( ( workspace: string ) => {
    const payload = {
      switchWorkspaceRequestWithoutRefreshTokenDto: {
        username: currentAccount?.userName || '',
        targetWorkspace: workspace,
      },
    };
    showUnmanagedLoader();
    workspaceService.switchWorkspace( payload, { withCredentials: true } )
      .then( ( response ) => {
        const accessToken = ( response?.data as SwitchWorkspaceResponseClass )?.accessToken;
        utils.updateAccessToken( accessToken );
        utils.updateAppAaccount( response?.data as TokenResponse );

        window.location.reload();
      } ).catch( ( error ) => {
        logger.error( error );
        window.location.reload();
      } );
  }, [ currentAccount, logger, showUnmanagedLoader, utils, workspaceService ] );

  const isMultiTenantList = utils.isMultiTenantList( workspaces );
  const processedList = ( isMultiTenantList ? utils.sortByTenantName( workspaces ) : workspaces )
    .filter( ( p ) => p.slug !== currentAccount.tenantSlug );
  const subItem = isMultiTenantList ? 'sub' : '';

  return (
    <>
      <hr className="mt-3 mb-3" />
      <li className="workspace-section">
        <h6 className="dropdown-header">{ t( 'profile.switchTo' ) }</h6>
        { processedList.map( ( workspace, index ) => (
          <Fragment key={ `ws-${index}` }>
            { isMultiTenantList && ( index < 1 || workspace.tenantName !== processedList[index - 1].tenantName ) && (
              <h6 className="dropdown-header sub">{ workspace.tenantName }</h6>
            ) }
            <Dropdown.Item
              className={ classNames( 'dropdown-item align-items-center', subItem, {
                'disabled': workspace.isDisabled,
              } ) }
              onClick={ workspace.isDisabled ? undefined : () => handleWorkspaceSwitch( workspace.slug ) }
              style={ workspace.isDisabled ? { cursor: 'not-allowed' } : undefined }
            >
              <i className="feather icon-tool" /> { utils.getWorkspaceName( workspace ) }
            </Dropdown.Item>
          </Fragment>
        ) ) }
      </li>
    </>
  );
};
